import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "admin-form panel-form" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "mt-2" };
const _hoisted_5 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_6 = { class: "mt-2" };
const _hoisted_7 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_8 = { class: "col-span-6" };
const _hoisted_9 = { class: "flex items-center" };
const _hoisted_10 = { class: "admin-form panel-form" };
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = { class: "mt-2" };
const _hoisted_13 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_14 = { class: "mt-2" };
const _hoisted_15 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_16 = { class: "flex mt-6 justify-end" };
const _hoisted_17 = { class: "ml-1" };
const _hoisted_18 = ["disabled"];
const _hoisted_19 = { class: "admin-form panel-form mt-6" };
const _hoisted_20 = { class: "form-group" };
const _hoisted_21 = {
    key: 0,
    class: "col-span-6 sm:col-span-4 text-sm"
};
const _hoisted_22 = {
    key: 0,
    class: "col-span-6 sm:col-span-4 text-sm mt-4"
};
const _hoisted_23 = { class: "bg-slate-50 text-sm text-slate-600 text-center p-2" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = { class: "flex col-span-6 mt-4" };
const _hoisted_26 = ["disabled"];
const _hoisted_27 = ["disabled"];
const _hoisted_28 = {
    key: 1,
    class: "col-span-6 lg:col-span-2 px-6 xl:pt-6 mx-auto w-64 p-4"
};
const _hoisted_29 = ["innerHTML"];
const _hoisted_30 = { class: "text-center mt-3 text-sm font-medium" };
const _hoisted_31 = { class: "form-control mt-3 text-center" };
const _hoisted_32 = ["disabled"];
const _hoisted_33 = {
    key: 2,
    class: "col-span-6 lg:col-span-4"
};
const _hoisted_34 = { class: "mt-2" };
const _hoisted_35 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_36 = { class: "form-control mt-6 text-right" };
const _hoisted_37 = ["disabled"];
const _hoisted_38 = {
    key: 3,
    class: "col-span-6 sm:col-span-4"
};
const _hoisted_39 = { class: "form-control mt-4" };
const _hoisted_40 = ["disabled"];
const _hoisted_41 = { class: "admin-form panel-form mt-6" };
const _hoisted_42 = { class: "form-group" };
const _hoisted_43 = { class: "col-span-6 xl:col-span-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_form_message = _resolveComponent("form-message");
    const _component_ConfirmationModal = _resolveComponent("ConfirmationModal");
    const _component_Loading = _resolveComponent("Loading");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "flex items-center mb-4" }, [
            _createElementVNode("h1", null, "Settings")
        ], -1)),
        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "top-help-block" }, [
            _createElementVNode("div", null, [
                _createElementVNode("span", { class: "text-brand-600" }, "*"),
                _createTextVNode(" denotes required field ")
            ])
        ], -1)),
        (_ctx.form.isLoaded())
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("form", {
                    action: "#",
                    method: "post",
                    enctype: "multipart/form-data",
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.form.update()), ["prevent"]))
                }, [
                    _createElementVNode("section", _hoisted_2, [
                        _cache[18] || (_cache[18] = _createElementVNode("aside", null, [
                            _createElementVNode("h2", { class: "font-medium text-lg" }, "Personal Information"),
                            _createElementVNode("p", null, " Your user account and privacy settings. ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('name') }])
                            }, [
                                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "name" }, [
                                    _createTextVNode("Name"),
                                    _createElementVNode("span", { class: "req-asterisk" }, "*")
                                ], -1)),
                                _createElementVNode("div", _hoisted_4, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        name: "name",
                                        id: "name",
                                        required: "",
                                        "aria-required": "true",
                                        autocomplete: "off",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.form.data.name) = $event))
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.data.name]
                                    ])
                                ]),
                                (_ctx.form.fieldHasErrors('name'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.form.getFieldError('name')), 1))
                                    : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("div", {
                                class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('email') }])
                            }, [
                                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "email" }, [
                                    _createTextVNode("Email"),
                                    _createElementVNode("span", { class: "req-asterisk" }, "*")
                                ], -1)),
                                _createElementVNode("div", _hoisted_6, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "email",
                                        name: "email",
                                        required: "",
                                        "aria-required": "true",
                                        id: "email",
                                        autocomplete: "off",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.form.data.email) = $event))
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.data.email]
                                    ])
                                ]),
                                (_ctx.form.fieldHasErrors('email'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.form.getFieldError('email')), 1))
                                    : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "marketing",
                                        name: "marketing",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.form.data.marketing) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.form.data.marketing]
                                    ]),
                                    _cache[17] || (_cache[17] = _createElementVNode("label", {
                                        for: "marketing",
                                        class: "ml-2 block text-sm text-slate-900"
                                    }, " Receive new offers by email? ", -1))
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("section", _hoisted_10, [
                        _cache[21] || (_cache[21] = _createElementVNode("aside", null, [
                            _createElementVNode("h2", { class: "font-medium text-lg" }, "Account Security"),
                            _createElementVNode("p", null, " Settings to keep your account secure. ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('new_password') }])
                            }, [
                                _cache[19] || (_cache[19] = _createElementVNode("label", { for: "new_password" }, "New Password", -1)),
                                _createElementVNode("div", _hoisted_12, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "password",
                                        name: "new_password",
                                        id: "new_password",
                                        autocomplete: "new-password",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.data.new_password) = $event))
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.data.new_password]
                                    ])
                                ]),
                                (_ctx.form.fieldHasErrors('new_password'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.form.getFieldError('new_password')), 1))
                                    : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("div", {
                                class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('new_password_confirmation') }])
                            }, [
                                _cache[20] || (_cache[20] = _createElementVNode("label", { for: "new_password_confirmation" }, "Password Confirmation", -1)),
                                _createElementVNode("div", _hoisted_14, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "password",
                                        name: "new_password_confirmation",
                                        id: "new_password_confirmation",
                                        autocomplete: "new-password",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.form.data.new_password_confirmation) = $event))
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.data.new_password_confirmation]
                                    ])
                                ]),
                                (_ctx.form.fieldHasErrors('new_password_confirmation'))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.form.getFieldError('new_password_confirmation')), 1))
                                    : _createCommentVNode("", true)
                            ], 2)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_form_message, { form: _ctx.form }, null, 8, ["form"]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                                type: "submit",
                                disabled: _ctx.form.isSubmitting()
                            }, "Update Settings", 8, _hoisted_18)
                        ])
                    ])
                ], 32),
                _createElementVNode("section", _hoisted_19, [
                    _cache[27] || (_cache[27] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Two Factor Authentication"),
                        _createElementVNode("p", null, " Manage Two Factor Authentication for your account. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_20, [
                        (_ctx.form.data.two_factor.enabled && _ctx.form.data.two_factor.confirmed)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex items-center" }, [
                                    _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "1.5",
                                        stroke: "currentColor",
                                        class: "text-teal-500 w-8 h-8 mr-2"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                                        })
                                    ]),
                                    _createTextVNode(" Two Factor Authentication is enabled on your account. ")
                                ], -1)),
                                (_ctx.form.show_recovery_codes)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "mb-6" }, " If you loose access to your authentication device, you can use these recovery codes to login to your account. Store them somewhere safe. ", -1)),
                                        _createElementVNode("ul", _hoisted_23, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.data.two_factor.rc, (code) => {
                                                return (_openBlock(), _createElementBlock("li", null, _toDisplayString(code), 1));
                                            }), 256))
                                        ]),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "alt text-sm justify-center px-6 mt-4",
                                            disabled: _ctx.form.mfa_loading,
                                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.form.regenerateRecoveryCodes()), ["prevent"]))
                                        }, " Re-generate Recovery Codes ", 8, _hoisted_24)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_25, [
                                    (!_ctx.form.show_recovery_codes)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "btn text-sm justify-center px-6 mr-2",
                                            disabled: _ctx.form.mfa_loading,
                                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.form.refreshUserSettings()), ["prevent"]))
                                        }, " Show Recovery Codes ", 8, _hoisted_26))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "btn text-sm justify-center px-6 mr-2",
                                            disabled: _ctx.form.mfa_loading,
                                            onClick: _cache[8] || (_cache[8] = _withModifiers(($event) => (_ctx.form.hideRecoveryCodes()), ["prevent"]))
                                        }, " Hide Recovery Codes ", 8, _hoisted_27)),
                                    _createVNode(_component_ConfirmationModal, {
                                        buttonClass: "error mr-2",
                                        buttonText: "Disable Two Factor Authentication",
                                        onConfirmAction: _cache[9] || (_cache[9] = ($event) => (_ctx.form.disableTwoFactorAuthentication()))
                                    }, {
                                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                                                    _createElementVNode("svg", {
                                                        class: "h-6 w-6 text-brand-600",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        stroke: "currentColor",
                                                        role: "img",
                                                        focusable: "false",
                                                        "aria-label": "Warning"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            "stroke-width": "2",
                                                            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                                        })
                                                    ])
                                                ], -1),
                                                _createElementVNode("div", { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }, [
                                                    _createElementVNode("h3", {
                                                        class: "text-lg leading-6 font-medium text-slate-900",
                                                        id: "modal-title"
                                                    }, "Disable Two Factor Authentication"),
                                                    _createElementVNode("div", { class: "mt-2 text-sm text-slate-500" }, [
                                                        _createElementVNode("p", { class: "my-1" }, " Are you sure you would like to disable two authentication? "),
                                                        _createElementVNode("p", { class: "my-1" }, " This action will render both your authenticator and back-up codes invalid, and will allow complete access to your account using only it's password. ")
                                                    ])
                                                ], -1)
                                            ]))]),
                                        _: 1
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.form.data.two_factor.enabled && _ctx.form.data.two_factor.confirmed === null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (_ctx.form.data.two_factor.qr)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        id: "qrcode_2fa",
                                        innerHTML: _ctx.form.data.two_factor.qr
                                    }, null, 8, _hoisted_29))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.form.data.two_factor.token), 1),
                                _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "error text-sm justify-center px-6",
                                        disabled: _ctx.form.mfa_loading,
                                        onClick: _cache[10] || (_cache[10] = _withModifiers(($event) => (_ctx.form.disableTwoFactorAuthentication()), ["prevent"]))
                                    }, " Cancel Two Factor Setup ", 8, _hoisted_32)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.form.data.two_factor.enabled && _ctx.form.data.two_factor.confirmed === null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _cache[25] || (_cache[25] = _createStaticVNode("<h4 class=\"font-medium text-lg\">Two Factor Authentication Setup </h4><ol class=\"my-2 list-decimal text-slate-600 text-sm\"><li class=\"py-2\"><span class=\"font-medium\">Download</span> your preferred two-factor authenticator application. If you don&#39;t already have one, we recommend <a href=\"https://support.google.com/accounts/answer/1066447\" target=\"_blank\">Google Authenticator</a>. </li><li class=\"py-2\"> Use your application to <span class=\"font-medium\">scan the QR code</span>. </li><li class=\"py-2\"> Enter the 6-digit code provided by your app and click &#39;Finish Two Factor Setup&#39; to verify. </li></ol>", 2)),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.form.fieldHasErrors('code') }])
                                }, [
                                    _createElementVNode("div", _hoisted_34, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            name: "code",
                                            required: "",
                                            "aria-required": "true",
                                            id: "code",
                                            autocomplete: "off",
                                            maxlength: "6",
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.form.data.code) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.form.data.code]
                                        ])
                                    ]),
                                    (_ctx.form.fieldHasErrors('code'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.form.getFieldError('code')), 1))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn text-sm justify-center px-6",
                                        disabled: _ctx.form.mfa_loading,
                                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event) => (_ctx.form.checkTwoFactorAuthentication()), ["prevent"]))
                                    }, " Finish Two Factor Setup ", 8, _hoisted_37)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (!_ctx.form.data.two_factor.enabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "flex items-center text-sm" }, [
                                    _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "1.5",
                                        stroke: "currentColor",
                                        class: "text-error-500 w-8 h-8 mr-2"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z"
                                        })
                                    ]),
                                    _createTextVNode(" You currently do not have two-factor authentication enabled. ")
                                ], -1)),
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn text-sm justify-center px-6",
                                        disabled: _ctx.form.mfa_loading,
                                        onClick: _cache[13] || (_cache[13] = _withModifiers(($event) => (_ctx.form.enableTwoFactorAuthentication()), ["prevent"]))
                                    }, " Configure Two Factor Authentication ", 8, _hoisted_40)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("section", _hoisted_41, [
                    _cache[29] || (_cache[29] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Delete Account"),
                        _createElementVNode("p", null, " Deleting your account will prevent you from logging in. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                            _createVNode(_component_ConfirmationModal, {
                                buttonClass: "error mr-2",
                                buttonText: "Delete Account",
                                onConfirmAction: _cache[14] || (_cache[14] = ($event) => (_ctx.form.delete()))
                            }, {
                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                        _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                                            _createElementVNode("svg", {
                                                class: "h-6 w-6 text-brand-600",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                role: "img",
                                                focusable: "false",
                                                "aria-label": "Warning"
                                            }, [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                                })
                                            ])
                                        ], -1),
                                        _createElementVNode("div", { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }, [
                                            _createElementVNode("h3", {
                                                class: "text-lg leading-6 font-medium text-slate-900",
                                                id: "modal-title"
                                            }, "Delete Account?"),
                                            _createElementVNode("div", { class: "mt-2" }, [
                                                _createElementVNode("p", { class: "text-sm text-slate-500" }, " Are you sure you would like to delete your account? Deleting your account will prevent you from logging in. ")
                                            ])
                                        ], -1)
                                    ]))]),
                                _: 1
                            })
                        ])
                    ])
                ])
            ]))
            : (_openBlock(), _createBlock(_component_Loading, {
                key: 1,
                message: "Loading Settings"
            }))
    ], 64));
}
